import { defineComponent as j, ref as C, onMounted as q, onUpdated as M, computed as w, openBlock as _, createElementBlock as b, createElementVNode as g, createVNode as l, unref as o, withCtx as m, createTextVNode as h, toDisplayString as k, Fragment as F, renderList as G, createBlock as A, normalizeClass as L, createCommentVNode as X } from "vue";
import H from "./ghl-ui.es180.js";
import J from "./ghl-ui.es401.js";
import "./ghl-ui.es23.js";
import "./ghl-ui.es35.js";
import "./ghl-ui.es6.js";
import "./ghl-ui.es55.js";
import "./ghl-ui.es13.js";
import K from "./ghl-ui.es402.js";
import { FixedUnit as p, DynamicUnit as S } from "./ghl-ui.es239.js";
import { marginUnits as N, limitsMeta as V, paddingUnits as I } from "./ghl-ui.es403.js";
import "./ghl-ui.es404.js";
import Q from "./ghl-ui.es137.js";
import W from "./ghl-ui.es76.js";
import Y from "./ghl-ui.es75.js";
import Z from "./ghl-ui.es329.js";
import ee from "./ghl-ui.es70.js";
import $ from "./ghl-ui.es126.js";
import te from "./ghl-ui.es125.js";
import ae from "./ghl-ui.es232.js";
import oe from "./ghl-ui.es242.js";
const ie = { class: "spacing-comp-dropdown" }, ne = { class: "spacing-comp-dropdown__container" }, ue = { class: "ghl-spacing__menu" }, le = { class: "ghl-spacing__menu-top" }, se = { class: "ghl-spacing__suggestion" }, re = { class: "ghl-spacing__footer" }, pe = j({
  __name: "Dropdown",
  props: {
    id: String,
    value: String,
    spaceType: {
      type: String,
      required: !0
    },
    positionType: {
      type: String,
      required: !0
    },
    defaultValue: {
      type: String,
      required: !0
    },
    showSuggestions: {
      type: Boolean,
      default: !0
    },
    placement: {
      type: String,
      default: "bottom"
    },
    readonly: Boolean
  },
  emits: [
    "update:value",
    "update:action",
    "update:popOverStatus"
  ],
  setup(v, { emit: B }) {
    const i = v, a = C(p.Auto), t = C("0"), T = B, D = (e) => {
      const s = a.value, n = Object.values(S);
      return a.value = e, n.includes(e) && n.includes(s) ? (r(), !1) : (e.includes("auto") ? t.value = p.Auto : t.value = "0", r(), !0);
    }, P = () => {
      const e = t.value.toString().trim();
      return a.value.includes("auto") ? (t.value = p.Auto, r(), !1) : isNaN(Number(e)) || !CSS.supports(
        `${i.spaceType}-${i.positionType}`,
        `${t.value}${a.value}`
      ) ? (t.value = "0", r(), !1) : (t.value = e, r(), !0);
    }, z = (e) => {
      t.value = e.toString(), r();
    }, E = (e) => {
      if (e === p.Auto)
        return t.value = p.Auto, a.value = p.Auto, r(), !1;
      a.value === p.Auto && (a.value = S.Pixels), t.value = e, r();
    }, O = () => {
      t.value = "0", a.value = S.Pixels, r();
    }, r = () => {
      T("update:value", {
        spaceType: i.spaceType,
        position: i.positionType,
        value: t.value,
        unit: a.value
      });
    }, x = (e) => {
      const s = /^(auto|-\d+(?:px|%|rem|em)|inherit|unset)$/;
      i.spaceType === "padding" && s.test(i.value) && (t.value = "0");
      const n = new RegExp(
        `(${Object.values(S).join("|")})`
      );
      if (e != null && e.includes("auto"))
        t.value = p.Auto, a.value = p.Auto;
      else if (n.test(e)) {
        const [d, c] = e.split(n);
        t.value = d, a.value = c;
      }
    };
    q(() => {
      const e = i.value ?? "0";
      x(e);
    }), M(() => {
      const e = i.value ?? "0";
      x(e);
    });
    const y = w(() => {
      var e, s, n, d, c, f;
      return i.spaceType === "margin" ? ((s = (e = N.find((u) => u.value === a.value)) == null ? void 0 : e.meta) == null ? void 0 : s.margin) ?? ((n = V.auto) == null ? void 0 : n.margin) : ((c = (d = I.find((u) => u.value === a.value)) == null ? void 0 : d.meta) == null ? void 0 : c.padding) ?? ((f = V.auto) == null ? void 0 : f.padding);
    }), U = w(() => CSS.supports(`${i.spaceType}-${i.positionType}`, i.value)), R = (e) => {
      T("update:popOverStatus", e);
    };
    return (e, s) => (_(), b("div", ie, [
      g("div", ne, [
        l(o(ae), {
          raw: "",
          trigger: "click",
          class: "override-shadow",
          placement: v.placement,
          disabled: v.readonly,
          "on-update:show": R
        }, {
          trigger: m(() => [
            l(K, {
              isValid: U.value,
              value: t.value,
              unit: a.value,
              positionType: v.positionType,
              readonly: v.readonly
            }, null, 8, ["isValid", "value", "unit", "positionType", "readonly"])
          ]),
          default: m(() => {
            var n, d, c, f;
            return [
              g("div", ue, [
                g("div", le, [
                  l(o(Q), {
                    disabled: a.value.includes("auto"),
                    min: (n = y.value) == null ? void 0 : n.min,
                    max: (d = y.value) == null ? void 0 : d.max,
                    value: Number(t.value),
                    "onUpdate:value": z,
                    tooltip: !1,
                    step: ((c = y.value) == null ? void 0 : c.step) ?? 1
                  }, null, 8, ["disabled", "min", "max", "value", "step"]),
                  l(o(W), null, {
                    default: m(() => [
                      l(o(Y), {
                        placeholder: null,
                        size: "small",
                        id: "spacing",
                        value: t.value,
                        "onUpdate:value": s[0] || (s[0] = (u) => t.value = u),
                        onBlur: P,
                        status: U.value ? void 0 : "error"
                      }, null, 8, ["value", "status"]),
                      l(o(Z), {
                        options: v.spaceType === "padding" ? o(I) : o(N),
                        value: a.value,
                        "onUpdate:value": D,
                        trigger: "click"
                      }, {
                        default: m(() => [
                          l(o(ee), {
                            id: "unit",
                            size: "small",
                            class: "units-button"
                          }, {
                            default: m(() => [
                              h(k(a.value !== "auto" ? a.value : "-"), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["options", "value"])
                    ]),
                    _: 1
                  })
                ]),
                l(o($)),
                g("div", se, [
                  (_(!0), b(F, null, G((f = y.value) == null ? void 0 : f.suggestions, (u) => (_(), A(o(oe), {
                    key: u,
                    size: "tiny",
                    id: u,
                    class: L([u === "auto" && "highlight", "ghl-spacing__suggestion--button"]),
                    onClick: (de) => E(u)
                  }, {
                    default: m(() => [
                      h(k(u.toUpperCase()), 1)
                    ]),
                    _: 2
                  }, 1032, ["id", "class", "onClick"]))), 128))
                ]),
                l(o($)),
                g("div", re, [
                  g("span", {
                    class: "clear",
                    onClick: O
                  }, [
                    l(o(J), { class: "w-4 h-4 text-gray-500 mr-1" }),
                    h(" Reset ")
                  ]),
                  U.value ? X("", !0) : (_(), A(o(te), {
                    key: 0,
                    class: "warning"
                  }, {
                    default: m(() => [
                      l(o(H)),
                      h(" Provided value is invalid. ")
                    ]),
                    _: 1
                  }))
                ])
              ])
            ];
          }),
          _: 1
        }, 8, ["placement", "disabled"])
      ])
    ]));
  }
}), Be = pe;
export {
  Be as default
};
